import {BaseContextMenu} from "./BaseContextMenu";

export class DefaultContextMenu extends BaseContextMenu {
    constructor() {
        super();

        this.addItem({
            name: 'center',
            group: 'default',
            title: 'Wyśrodkuj do tego miejsca',
            onClick: (contextMenuFeature, epMap) => {
                epMap.map.getView().setCenter(contextMenuFeature.position);

                return true;
            }
        })

        this.addItem({
            name: 'ruler',
            group: 'ruler',
            title: 'Zmierz odległość',
            shouldRender: (contextMenuFeature, epMap) => epMap.ruler != null,
            onClick: (contextMenuFeature, epMap) => {
                epMap.ruler.start(contextMenuFeature.position);

                return true;
            }
        })

        this.addItem({
            name: 'ruler-remove',
            group: 'ruler',
            title: 'Usuń pomiar',
            shouldRender: (contextMenuFeature, epMap) => {
                if(epMap.ruler == null) {
                    return false;
                }

                let features = contextMenuFeature
                    .getFeaturesAtClickedPosition(10)
                    .filter(feature => feature.get('type') === 'ruler-measure');

                return features.length > 0;
            },
            onClick: (contextMenuFeature, epMap) => {
                if(!epMap.ruler) {
                    return false;
                }

                let features = contextMenuFeature
                    .getFeaturesAtClickedPosition(10)
                    .filter(feature => feature.get('type') === 'ruler-measure');

                if(features.length > 0) {
                    epMap.ruler.removeMeasure(features[0].getId());
                }

                return true;
            }
        })

        this.addItem({
            name: 'ruler-clear',
            group: 'ruler',
            title: 'Usuń wszystkie pomiary',
            shouldRender: (contextMenuFeature, epMap) => {
                return epMap.ruler != null && epMap.ruler.getNumberOfMeasurements() > 0;
            },
            onClick: (contextMenuFeature, epMap) => {
                epMap.ruler.clear();

                return true;
            }
        })
    }
}